export interface FontSize {
  h1: string
  h2: string
  copy: string
  smallCopy: string
  label: string
  button: string
}

export const FontSizes: FontSize = {
  h1: '25px',
  h2: '19px',
  copy: '16px',
  smallCopy: '12px',
  label: '12px',
  button: '16px',
}
